// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactIcons_wrapper__UHknD","icon":"ContactIcons_icon__4mulx","title":"ContactIcons_title__jJWUI","description":"ContactIcons_description__-trmh"};